import { LabelEditorUtils } from './label-editor-utils';

export class DefaultTextParameters {

  private _bold: boolean = true;
  private _fontSize: number = LabelEditorUtils.DEFAULT_FONT_SIZE;

  constructor(fontSize: number = LabelEditorUtils.DEFAULT_FONT_SIZE, bold: boolean = true) {
    this._fontSize = fontSize;
    this._bold = bold;
  }

  public get fontSize(): number {
    return this._fontSize;
  }

  public get bold(): boolean {
    return this._bold;
  }

  public get html5DataFontSize(): number {
    return LabelEditorUtils.convertFontSizeToHTML5DataFontSize(this._fontSize);
  }

}
